import * as analytic from '@anm/analytic';
import ShareButton from '@anm/components/share/ShareButton';
import * as semrush from '@anm/helpers/semrush';
import toCamelCase from '@anm/helpers/string/toCamelCase';
import { Component } from 'react';
import { compose } from 'recompose';

import withAppMeta, { WithAppMetaProps } from '../../HOCs/withAppMeta';
import withCalendar, { WithCalendarInsertedProps, WithCalendarProps } from '../../HOCs/withCalendar';

import CalendarSync from './CalendarSync';
import DayColumn from './DayColumn';
import DaysContainer from './DaysContainer';
import WeekSwitcher from './WeekSwitcher';
import CalendarWrapper, { CalendarHeader, CalendarHeaderButtons, CalendarTitle } from './Wrapper';

type HOCs = WithAppMetaProps & WithCalendarInsertedProps & {};

export type CalendarProps = WithCalendarInsertedProps & {
  children: (year: number, month: number, date: number) => JSX.Element | null;
};

class Calendar extends Component<CalendarProps & HOCs> {
  renderDaysColumn() {
    const { calendarInfo, children: renderContent } = this.props;
    const { days: daysColumnData } = calendarInfo;

    const daysColumn = daysColumnData.map(({ date, title, year, month, isActive }) => {
      return (
        <DayColumn key={title} date={date} dayTitle={title} isActive={isActive}>
          {renderContent(year, month, date)}
        </DayColumn>
      );
    });

    return <>{daysColumn}</>;
  }

  render() {
    const {
      calendarInfo,
      toDay,
      toPreviousWeek,
      toNextWeek,
      appMeta: { path }
    } = this.props;
    const { year, monthTitle } = calendarInfo;

    const CALENDAR_TITLE = 'Free Social Calendar';

    return (
      <CalendarWrapper>
        <CalendarHeader>
          <WeekSwitcher onToDayClick={toDay} onSwitchLeft={toPreviousWeek} onSwitchRight={toNextWeek} />
          <CalendarTitle>
            <div data-title={toCamelCase(CALENDAR_TITLE)}>{CALENDAR_TITLE}</div>
            {monthTitle} {year}
          </CalendarTitle>
          {!semrush.isSemrushIframe() && (
            <CalendarHeaderButtons>
              <CalendarSync />
              <ShareButton link={path} onShare={analytic.trackShareEvent} />
            </CalendarHeaderButtons>
          )}
        </CalendarHeader>
        <DaysContainer>{this.renderDaysColumn()}</DaysContainer>
      </CalendarWrapper>
    );
  }
}

export default compose<{}, WithCalendarProps>(withCalendar, withAppMeta)(Calendar);
